var map = {
	"./error-dark.svg": "./src/assets/images/pages/error-dark.svg",
	"./error.svg": "./src/assets/images/pages/error.svg",
	"./forgot-password-v2-dark.svg": "./src/assets/images/pages/forgot-password-v2-dark.svg",
	"./forgot-password-v2.svg": "./src/assets/images/pages/forgot-password-v2.svg",
	"./login-v2-dark.svg": "./src/assets/images/pages/login-v2-dark.svg",
	"./login-v2.svg": "./src/assets/images/pages/login-v2.svg",
	"./not-authorized-dark.svg": "./src/assets/images/pages/not-authorized-dark.svg",
	"./not-authorized.svg": "./src/assets/images/pages/not-authorized.svg",
	"./register-v2-dark.svg": "./src/assets/images/pages/register-v2-dark.svg",
	"./register-v2.svg": "./src/assets/images/pages/register-v2.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/pages sync recursive ^\\.\\/.*$";